import { createFileRoute, useParams } from '@tanstack/react-router';

import { InfoTab } from '@/views/admin/courses/tabs/info-tab.tsx';

export const Route = createFileRoute('/admin/courses_/$id/info')({
  component: InfoRoute,
});

function InfoRoute() {
  const { id } = useParams({ from: '/admin/courses_/$id/info' });
  return <InfoTab id={id} isNew={id === 'new'} />;
}
